"use client";
import * as React from "react";
const SvgBackspaceRound = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 16 12", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "M14.66 0H4.56c-.46 0-.83.23-1.07.59L.11 5.63a.7.7 0 0 0 0 .74l3.4 5.04c.23.35.6.59 1.06.59h10.09c.74 0 1.34-.6 1.34-1.33V1.33A1.34 1.34 0 0 0 14.65 0m-2.48 8.87a.67.67 0 0 1-.95 0L9.28 6.94 7.33 8.87a.67.67 0 0 1-.94 0 .66.66 0 0 1 0-.94L8.32 6 6.38 4.07a.66.66 0 0 1 0-.94.67.67 0 0 1 .95 0l1.95 1.93 1.94-1.93a.67.67 0 0 1 .95 0 .66.66 0 0 1 0 .94L10.22 6l1.95 1.93a.67.67 0 0 1 0 .94" }));
export {
  SvgBackspaceRound as default
};
